(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sabrina-navigation"]) return;
  try {
    
function initSabrinaNavigation(root=document){root.querySelectorAll('.sf-navigation').forEach(header=>{if(header.dataset.ready)return;header.dataset.ready='true';const toggle=header.querySelector('.sf-menu-toggle');const groups=[...header.querySelectorAll('.sf-nav-group')];const close=()=>{header.removeAttribute('data-open');toggle.setAttribute('aria-expanded','false');groups.forEach(d=>d.open=false)};toggle.addEventListener('click',()=>{const open=!header.hasAttribute('data-open');header.toggleAttribute('data-open',open);toggle.setAttribute('aria-expanded',String(open))});groups.forEach(group=>{let timer;group.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'&&innerWidth>1050){clearTimeout(timer);groups.filter(x=>x!==group).forEach(x=>x.open=false);group.open=true}});group.addEventListener('pointerleave',()=>{if(innerWidth>1050)timer=setTimeout(()=>{if(!group.contains(document.activeElement))group.open=false},120)});group.addEventListener('focusout',()=>{setTimeout(()=>{if(!group.contains(document.activeElement))group.open=false},0)})});header.addEventListener('keydown',event=>{if(event.key==='Escape'){const group=event.target.closest('.sf-nav-group');if(group){group.open=false;group.querySelector('summary').focus()}else{close();toggle.focus()}}});document.addEventListener('click',event=>{if(!header.contains(event.target))close()})})}initSabrinaNavigation();document.addEventListener('shopify:section:load',event=>initSabrinaNavigation(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sabrina-page"] && !Shopify.designMode) return;
  try {
    
  function initSabrinaComparisons(root = document) {
    root.querySelectorAll('[data-sabrina-compare]').forEach((figure) => {
      const slider = figure.querySelector('[data-sabrina-compare-range]');
      if (!slider || slider.dataset.ready) return;
      slider.dataset.ready = 'true';
      const update = () => {
        const position = Number(slider.value);
        figure.style.setProperty('--compare-position', `${position}%`);
        figure.querySelector('.sabrina-compare__label--before').hidden = position === 0;
        figure.querySelector('.sabrina-compare__label--after').hidden = position === 100;
        figure.querySelector('.sf-compare-handle').hidden = position === 0 || position === 100;
        figure.querySelectorAll('[data-compare-view]').forEach(b => b.setAttribute('aria-pressed', String(Number(b.dataset.compareView) === position)));
        slider.setAttribute('aria-valuetext', `${position}% before, ${100-position}% after`);
      };
      slider.addEventListener('input', update);
      figure.querySelectorAll('[data-compare-view]').forEach(button => button.addEventListener('click', () => { slider.value = button.dataset.compareView; update(); }));
      const surface = figure.querySelector('.sabrina-compare__images');
      const move = (event) => { const rect = surface.getBoundingClientRect(); slider.value = Math.min(100, Math.max(0, ((event.clientY - rect.top) / rect.height) * 100)); update(); };
      surface.addEventListener('pointerdown', (event) => { surface.setPointerCapture(event.pointerId); move(event); });
      surface.addEventListener('pointermove', (event) => { if(surface.hasPointerCapture(event.pointerId)) move(event); });
      surface.addEventListener('pointerup', (event) => { if(surface.hasPointerCapture(event.pointerId)) surface.releasePointerCapture(event.pointerId); });
      update();
    });
  }
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href="#BridalEnquiry"],a[href="#SabrinaBridalEnquiryTitle"]');
    if (link) { const form = document.getElementById('BridalEnquiry'); if(form) form.open = true; }
  });
  initSabrinaComparisons();
  document.addEventListener('shopify:section:load', (event) => initSabrinaComparisons(event.target));

  document.querySelectorAll('[data-sabrina-faq]').forEach((faq) => {
    const input = faq.querySelector('[data-sabrina-faq-search]');
    const items = [...faq.querySelectorAll('[data-sabrina-faq-item]')];
    const groups = [...faq.querySelectorAll('.sabrina-faq__group')];
    const status = faq.querySelector('[data-sabrina-faq-status]');
    const empty = faq.querySelector('[data-sabrina-faq-empty]');
    if (!input) return;
    input.addEventListener('input', () => {
      const query = input.value.trim().toLowerCase();
      let visible = 0;
      items.forEach((item) => {
        const match = !query || item.textContent.toLowerCase().includes(query);
        item.hidden = !match;
        if (match) visible += 1;
      });
      groups.forEach((group) => {
        group.hidden = !group.querySelector('[data-sabrina-faq-item]:not([hidden])');
      });
      empty.hidden = visible > 0;
      status.textContent = query ? `${visible} matching ${visible === 1 ? 'question' : 'questions'}` : 'Showing all questions';
    });
  });

  document.querySelectorAll('[data-bridal-enquiry]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (!form.reportValidity()) return;
      const data = new FormData(form);
      const lines = [
        `Name: ${data.get('name') || ''}`,
        `Email: ${data.get('email') || ''}`,
        `Telephone: ${data.get('phone') || ''}`,
        `Wedding date: ${data.get('date') || ''}`,
        `Wedding venue and address: ${data.get('venue') || ''}`,
        `Ceremony time: ${data.get('ceremony') || ''}`,
        `Getting ready: ${data.get('getting_ready') || ''}`,
        `Getting-ready address: ${data.get('getting_ready_address') || ''}`,
        `Number of people: ${data.get('party_size') || ''}`,
        `Services: ${data.get('services') || ''}`,
        `Preferred trial location: ${data.get('trial') || ''}`,
        '',
        'Dress, accessories, references and the feeling of the day:',
        `${data.get('details') || ''}`,
        '',
        'Starting prices acknowledged: Yes'
      ];
      const subject = `Bridal enquiry · ${data.get('date') || 'date to follow'} · ${data.get('name') || ''}`;
      window.location.href = `mailto:contact@studioshy.co.uk?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(lines.join('\n'))}`;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
